import React from 'react';

const GeniusError = ({ error }) => {
  return (
    <div className=" h-[14px]  flex justify-end text-red-500">{error}</div>
  );
};

export default GeniusError;
